module.exports = __webpack_public_path__ + "img/physician2.fef20611.svg";